import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SaveConfigHybridRequest, SaveFinalCommissionSubSchema } from 'src/app/model/other-catalogs-models';

@Injectable({
  providedIn: 'root'
})
export class CatHybridCommissionSchemaService {

  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  getAll=()=> {
    return this.http.get(`${this.url}/CatHybridCommissionSchema/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getConfigBySchemaId=(HybridSchemaId)=> {
    return this.http.get(`${this.url}/CatHybridConfig/List?HybridSchemaId=${HybridSchemaId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  save=(SaveConfigHybridRequest: SaveConfigHybridRequest )=> {
    console.log(SaveConfigHybridRequest)
    return this.http.post(`${this.url}/CatHybridCommissionSchema/SaveNewSchema`, SaveConfigHybridRequest)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  saveSubSquema=(saveRequestDTO: SaveFinalCommissionSubSchema )=> {
    console.log(saveRequestDTO)
    return this.http.post(`${this.url}/SubSchema/SaveNewSchema`, saveRequestDTO)
      .pipe(
        map((resp:any)=> resp)
      );
  }
 
  getSelectedSchemas=(HybridSchemaId:string)=> {
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/ListCSSelected?HybridSchemaId=${HybridSchemaId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }


}
